import React, { useContext, useState } from "react";
import "./ToolBarLeftPanel.scss";
import ModuleCard from "./ModuleCard";
import expandIcon from '../../images/right_arrow.svg';
import CircularProgressBar from "../../utils/CircularProgressBar";
//  import ValueContext from "../../ContextAPi/appContext";

const ModuleCardsWindow = ({
  setSelectedModule,
  setOpenModulesScreen,
  setOpenModulesModal,
  handleModuleWindow,
  handleExpandModuleClaims,
  handleGetChildModules,
  sendAtomDetails2Canvas,
  associatedCards,
  moduleCardsDataLHS, 
  isLoading,
  setIsLoading,
  activeTab
}) => {
  //const appData = useContext(ValueContext);
  const handleEditSelection = () => {
    //appData.setnewBanner(false)
    setOpenModulesModal(true);
    setOpenModulesScreen(true);
  }



  return (
    <>
      {isLoading && (
        <CircularProgressBar
            isloading={isLoading}
            setIsloading={setIsLoading}
        />
      )}
      <div className="selected-module-window custonScrollBar">
        <div>
        
          <div
            className="mb-3"
            style={{
              width: "100%",
              backgroundColor: "#DDDFDD",
              height: "1px",
              marginTop: "-1px",
            }}
          ></div>
        </div>

        <div className="edit-secContainer">
          <div className="edit-module-selection">
            <div className="edit-section mb-3"
            onClick={handleModuleWindow}
            style={{ cursor: "pointer" }}
          >
              Edit Module Selection
              <img src={expandIcon} />
            </div>
          </div>
          {isLoading && (
            <>
             <CircularProgressBar
              isloading={isLoading}
              setIsloading={setIsLoading}
             />
            </>
          )}
          <div className="cardscroll custonScrollBar" >
            {moduleCardsDataLHS?.map((moduleIds, index) => {
              return (

                <ModuleCard
                  key={moduleIds.id}
                  card={moduleIds}
                  setSelectedModule={setSelectedModule}
                 // selectedModule={selectedModule}
                //  linkedModulesType={linkedModulesType}
                  handleExpandModuleClaims={handleExpandModuleClaims}
                  sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                  handleGetChildModules={handleGetChildModules}
                  associatedCards={associatedCards}
                  activeTab={activeTab}
                  moduleCardsDataLHS={moduleCardsDataLHS}
                //  noBussinessRules={noBussinessRules}
                />

              );
            })}  </div>
        </div>
      </div>
    </>
  );
};

export default ModuleCardsWindow;
